export default __webpack_public_path__ + "static/media/what-the.24c3fa79.svg";